import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import Image from 'gatsby-image';
import Page from '../components/Page';
import SEO from '../components/SEO';
import { FlexContainer, Portrait, Greeting, Profession, LinkButton, GatsbyLinkButton } from '../styles';
export default (function (_ref) {
    var portrait = _ref.data.portrait;
    return /*#__PURE__*/ _jsxs(Page, {
        children: [/*#__PURE__*/ _jsx(SEO, {
                title: "Home"
            }), /*#__PURE__*/ _jsxs(FlexContainer, {
                w: "100%",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                flexGrow: 1,
                children: [/*#__PURE__*/ _jsx(Portrait, {
                        children: /*#__PURE__*/ _jsx(Image, {
                            fixed: portrait.childImageSharp.fixed,
                            style: {
                                borderRadius: '100%'
                            }
                        })
                    }), /*#__PURE__*/ _jsx(Greeting, {
                        children: "Hello, I'm Le Kang"
                    }), /*#__PURE__*/ _jsx(Profession, {
                        children: "I develop Web and Robot applications"
                    }), /*#__PURE__*/ _jsx(LinkButton, {
                        href: "../../resume-le-kang.pdf",
                        target: "_blank",
                        children: "View R\xE9sum\xE9"
                    }), /*#__PURE__*/ _jsx(GatsbyLinkButton, {
                        to: "/contact/",
                        children: "Contact me"
                    })]
            })]
    });
});
var query = "1984634865";
